module.exports = __webpack_public_path__ + "static/media/007-star-green.4521056a.svg";